import { BaseModel } from './base';

export class  Bank extends BaseModel{
  bankName: string;
  sortCode: string;
  logo: string;
}
